import { render, staticRenderFns } from "./NewMessageNotify.vue?vue&type=template&id=3f9a8aa4&scoped=true"
import script from "./NewMessageNotify.vue?vue&type=script&lang=js"
export * from "./NewMessageNotify.vue?vue&type=script&lang=js"
import style0 from "./NewMessageNotify.vue?vue&type=style&index=0&id=3f9a8aa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a8aa4",
  null
  
)

export default component.exports